<template>
  <div>
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title">Deuda entre Clubes</v-toolbar-title>
    </v-toolbar>
    <div v-if="loading" class="spacing-top">
      <v-flex offset-xs5 pa-5>
        <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
      </v-flex>
    </div>
    <div v-else class="spacing-top">
      <v-card>
        <v-layout row wrap>
          <v-flex xs12 md3 pt-4 pl-4 ml-2 pb-4>
                <div v-if="$store.getters.isSafRole"><b>Club deudor:</b> {{ deuda.clubDeudor.nombre }}</div>
                <div><b>Club acreedor:</b> {{ deuda.clubAcreedor.nombre }}</div>
                <div v-if="deuda.jugador"><b>Jugador:</b> {{ deuda.jugador }}</div>
                <div><b>Estado:</b> {{ deuda.estadoDisplay }}</div>
                <br>
                <div v-for="saldo in deuda.saldos" :key="saldo.moneda">
                  <b>Saldo {{ saldo.moneda }}: </b>
                  <span :class="saldo.importeTotal - saldo.importePago > 0 ? 'debe' : 'pago'">
                    {{ saldo.importeTotal - saldo.importePago | formatAsCurrency }}
                  </span>
                </div>
          </v-flex>
          <v-divider vertical></v-divider>
          <v-flex xs12  pl-4 md4 pt-4 pb-4>
            <v-layout column wrap>
              <div><b>Contrato:</b></div>
              <a :href="deuda.contrato.url" target="_blank">{{ deuda.contrato.name }}</a>
              <span v-if="deuda.contrato.description" class="text-xs-left">{{ deuda.contrato.description }}</span>
            </v-layout>
          </v-flex>
          <v-divider vertical></v-divider>
          <v-flex xs12 md4  pl-4 pt-4 pr-2 pb-4>
            <v-layout column wrap v-if="$store.getters.isSafRole">
              <v-btn @click="confirmHabilitar" class="primary" v-if="deuda.puedeHabilitarCarga">Habilitar Carga</v-btn>
              <v-btn @click="confirmActivar" class="primary" v-else :disabled="!deuda.puedeSerActivada">{{ deuda.estado === 0 ? 'Activar' : 'Aprobar' }}</v-btn>
              <v-btn @click="confirmRechazar" class="primary" :disabled="!deuda.puedeRechazar">Rechazar</v-btn>
              <v-btn @click="confirmFinalizar" class="primary" :disabled="!deuda.puedeFinalizar">Finalizar</v-btn>
            </v-layout>
            <v-layout column wrap v-else>
              <v-btn @click="confirmPresentar" class="primary" :disabled="!deuda.puedePresentar">Presentar</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
      <cuotas-table ref="cuotasTable" @goCuota="goCuota" @changeStatus="changeCuotaStatus"></cuotas-table>
      <creacion-cuota-popup-form ref="cuotaPopup" @updatedCuota="refreshDeuda" @changeStatus="changeCuotaStatus"></creacion-cuota-popup-form>
      <v-divider></v-divider>
      <div v-if="$store.getters.isClubRole">
        <ConfirmationDialog ref="confirmPresentar" :function-yes="presentarDeuda"
          title="¿Presentar deuda?" text="¿Desea presentar esta deuda?"></ConfirmationDialog>
      </div>
      <div v-if="$store.getters.isSafRole">
        <ConfirmationDialog ref="confirmHabilitar" :function-yes="habilitarDeuda" title="¿Habilitar deuda?"
          text="¿Desea habilitar la carga de comprobantes para esta deuda?"></ConfirmationDialog>
        <ConfirmationDialog ref="confirmFinalizar" :function-yes="finalizarDeuda" title="¿Finalizar deuda?"
          text="¿Desea finalizar de esta deuda?"></ConfirmationDialog>
        <ConfirmationDialog ref="confirmActivar" :function-yes="activarDeuda" title="¿Activar deuda?"
          text="¿Desea finalizar de esta deuda?"></ConfirmationDialog>
        <ConfirmationDialog ref="confirmRechazar" :function-yes="rechazarDeuda" title="¿Rechazar deuda?"
          text="¿Desea rechazar de esta deuda?" v-if="!deuda.plazoMaximoSubsanacion"></ConfirmationDialog>
        <subsanar-popup ref="confirmRechazar" @rechazado="goBack" :maxDias="deuda.plazoMaximoSubsanacion"
          v-else></subsanar-popup>
      </div>
      <go-back-button/>
    </div>
    <v-btn app dark fixed fab bottom right class="add-button" @click="cuotaNueva" v-if="deuda.canEdit && $store.getters.isSafRole">
      <v-icon>add</v-icon>
    </v-btn>
  </div>

</template>

<script>
import GoBackButton from '../../../common/ui/GoBackButton'
import CuotasTable from '../components/CuotasTable.vue'
import CreacionCuotaPopupForm from '../components/CreacionCuotaPopupForm'
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'
import SubsanarPopup from '../components/SubsanarPopup'

export default {

  components: {
    GoBackButton,
    CuotasTable,
    CreacionCuotaPopupForm,
    ConfirmationDialog,
    SubsanarPopup
  },

  data () {
    return {
      dialog: false,
      loading: true,
      path: `/deuda/${this.$route.params.id}`,
      deuda: {}
    }
  },

  filters: {
    formatAsCurrency (importe) {
      const monto = Number(importe).toLocaleString('es', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      return `$ ${monto}`
    }
  },

  methods: {
    changeCuotaStatus (cuotaId, estado) {
      const path = `cuota/corregir/${cuotaId}/${estado}`
      this.axios
        .put(path)
        .then(response => { this.refreshDeuda() })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    goBack () {
      this.$router.go(-1)
    },
    cambiarEstadoDeuda (path) {
      this.axios
        .put(path)
        .then(response => {
          this.deuda = response.data
          this.goBack()
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    activarDeuda () {
      const activarPath = `deuda/${this.deudaId}/activar`
      this.cambiarEstadoDeuda(activarPath)
    },
    habilitarDeuda () {
      const habilitarPath = `deuda/${this.deudaId}/habilitar-carga`
      this.cambiarEstadoDeuda(habilitarPath)
    },
    finalizarDeuda () {
      const finalizarPath = `deuda/${this.deudaId}/finalizar`
      this.cambiarEstadoDeuda(finalizarPath)
    },
    rechazarDeuda () {
      const rechazarPath = `deuda/${this.deudaId}/rechazar`
      this.cambiarEstadoDeuda(rechazarPath)
    },
    presentarDeuda () {
      const presentarPath = `deuda/${this.deudaId}/presentar`
      this.cambiarEstadoDeuda(presentarPath)
    },
    goCuota (cuotaId) {
      this.$refs.cuotaPopup.showDialog(cuotaId)
    },
    fetchData () {
      this.axios
        .get(this.path)
        .then(response => {
          this.deuda = response.data
          this.loading = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    refreshDeuda () {
      this.fetchData()
      this.refreshTable()
    },
    refreshTable () {
      this.$refs.cuotasTable.refreshTable()
    },
    cuotaNueva () {
      this.$refs.cuotaPopup.showDialog()
    },
    confirmHabilitar () {
      this.$refs.confirmHabilitar.openDialog()
    },
    confirmActivar () {
      this.$refs.confirmActivar.openDialog()
    },
    confirmRechazar () {
      this.$refs.confirmRechazar.openDialog()
    },
    confirmFinalizar () {
      this.$refs.confirmFinalizar.openDialog()
    },
    confirmPresentar () {
      this.$refs.confirmPresentar.openDialog()
    }
  },

  computed: {
    deudaId () {
      return this.$route.params.id
    }
  },

  created () {
    this.fetchData()
  }
}
</script>

<style scoped>
  .spacing-top {
    margin-top: 6em;
  }
  .debe {
    color: red;
  }
  .pago {
    color: green;
  }
  .documento-error {
    color: red;
  }
</style>
